__turbopack_context__.v({
  "Clabel": "profile-module__3PoNdq__Clabel",
  "ProchildField": "profile-module__3PoNdq__ProchildField",
  "Profield": "profile-module__3PoNdq__Profield",
  "UserProfile": "profile-module__3PoNdq__UserProfile",
  "customFileInput": "profile-module__3PoNdq__customFileInput",
  "date": "profile-module__3PoNdq__date",
  "dob": "profile-module__3PoNdq__dob",
  "downarrow": "profile-module__3PoNdq__downarrow",
  "error": "profile-module__3PoNdq__error",
  "field": "profile-module__3PoNdq__field",
  "inputContainer": "profile-module__3PoNdq__inputContainer",
  "loginBtn": "profile-module__3PoNdq__loginBtn",
  "parent": "profile-module__3PoNdq__parent",
  "proMain": "profile-module__3PoNdq__proMain",
  "updateBtn": "profile-module__3PoNdq__updateBtn",
  "watchNow": "profile-module__3PoNdq__watchNow",
});
